import { render } from "./SmartboxSettingsModal.vue?vue&type=template&id=0832d196"
import script from "./SmartboxSettingsModal.vue?vue&type=script&lang=js"
export * from "./SmartboxSettingsModal.vue?vue&type=script&lang=js"
script.render = render

export default script